"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Background = _interopRequireDefault(require("./Background.style"));

var Background = function Background(_ref) {
  var percent = _ref.percent;
  return _react.default.createElement(_Background.default, {
    style: {
      transform: "scaleX(".concat(percent / 100, ")")
    }
  });
};

Background.propTypes = {
  percent: _propTypes.default.number.isRequired
};
var _default = Background;
exports.default = _default;